// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jg_a bhi_a bhi_j bhi_q bhi_st bhi_su bhi_w"};